import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as _ from "lodash";
import { ModalViewreseauDeSoinDetailComponent } from "src/app/shared/components/modal-view-reseau-soin-detail/modal-view-reseau-soin-detail.component";
import * as moment from "moment";
import { ModalViewBaremeDetailComponent } from "src/app/shared/components/modal-view-bareme-detail/modal-view-bareme-detail.component";
import { ModalAddBaremeComponent } from "../../bareme/modal-add-bareme/modal-add-bareme.component";
import { ModalAddGarantComponent } from "../../garant/modal-add-garant/modal-add-garant.component";
import { ModalAddPoliceComponent } from "../../police/modal-add-police/modal-add-police.component";

@Component({
  selector: 'app-modal-add-college',
  templateUrl: './modal-add-college.component.html',
  styleUrls: ['./modal-add-college.component.scss']
})
export class ModalAddCollegeComponent implements OnInit {

  listItems: Array<any> = [];
  items: Array<any> = [];
  itemToSave: any = {};
  filiale_id:any
  uniteFonctionnelleSelected: any = {};
  modalRef: BsModalRef;
  user: any = {};
  isDetailMode:any=false
  itemToSearch: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 10;
  totalItems: number;
  show_password_field = true
  busyGet: Subscription;
  busySave: Subscription;
  loading: boolean = false;
  endPoint: string = "college";
  title:string='collège'
  createMessage = ''
  editMessage =''
  deleteMessage =''
  itemsListeModeGestAvenant:any=[{value:'MANUEL',libelle:'MANUEL'},{value:'AUTOMATIQUE',libelle:'AUTOMATIQUE'}]
  itemsPeriodiciteAvenant:any=[{value:'JOUR',libelle:'JOUR'},{value:'MOIS',libelle:'MOIS'},{value:'TRIMESTRE',libelle:'TRIMESTRE'},{value:'SEMESTRE',libelle:'SEMESTRE'},{value:'ANNEE',libelle:'ANNEE'},{value:'EXERCICE',libelle:'EXERCICE'}]
  itemsParentFonctionnalites=[]
  itemsRemboursement = [
    {code:'ASSURE',libelle:'ASSURE PRINCIPAL'},
    {code:'CONJOINT',libelle:'CONJOINT'},
    {code:'SOUSCRIPTEUR',libelle:'SOUSCRIPTEUR'},
    {code:'ENFANT',libelle:'ENFANT'},
    {code:'ASCENDANT',libelle:'ASCENDANT'},
  ]

  gender='F'
  itemsRole: any;
  itemsSpecialites: any;
  itemsCivilite:any=[]
  itemsGenre:any=[]
  itemsFiliale:any=[]
  searchKey:any
  dateNais: any;
  bsValue: Date;
  imageName: string;
  imageDisplay: any;
  currentItemImage: {
    fileBase64: any;
    fileName: any;
    extension: any;
    typeDocument: string;
  };
  selectedUniteFoncId: any;
  selectedSpecialiteId: any;
  listSelectedUniteFonctionnelle = [];
  isAutoPassword=false
  maxDate = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth() - 1,
    new Date().getDay()
  );
  minDate = new Date();
  itemsFucntParent: any[];
  itemsTypeGarant: any;
  itemsTypeRemboursement: any;
  itemsCourtier: any[];
  itemsCommercial: any;
  itemsSouscripteur: any;
  itemsCategoriePolice: any[];
  currentData:any
  itemsModeTarification: any;
  itemsReseauDeSoin: any;
  itemsGarant: any;
  itemsAgence: any[];
  itemsStatutPolice: any;
  itemsStatutCollege: any[];
  itemsPolice: any[];
  itemsBareme: any;
  itemsModeProrata: any;
  current_police_id: any;
  selected_police: any;
  itemsEtenduTerritoire: any;
  systemGlobal: any=[];
  is_tpg: boolean=false;
  itemsTypeTarif: any;
  itemsTarif: any;
  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService
  ) {
        // this.user = this.authService.currentUserValue;
        this.user = this.authService.getCurrentUser()
        // console.info('user-->: ',this.user)
        this.filiale_id = this.user.filiale_id
        let text1 = this.gender=='M'?'un':'une'
        this.createMessage = 'Vous êtes sur le point de créer '+text1+' '+this.title
        this.editMessage = 'Vous êtes sur le point de modifier '+text1+' '+this.title

    setTimeout(() => {
      console.log('here');
      
      if (this.currentData) {
        console.log("currentData: ",this.currentData)
        this.itemToSave = Object.assign({}, this.currentData);
        console.log('itemToSave: ',this.itemToSave)

        // this.onSelectGarant()
        this.itemToSave.date_effet = moment(this.itemToSave.date_effet).toDate()
        this.itemToSave.date_echeance = moment(this.itemToSave.date_echeance).toDate()
        this.getItemsTypeRemboursement()
        console.log("this.itemToSave: ",this.itemToSave)
        if(this.itemToSave.garant_id){
          this.itemToSearch.garant_id = this.itemToSave.garant_id
          this.getItemsPolice()
          this.getItemsBareme()

        }

        console.log("sessionMode in college: ",this.currentData.sessionMode)


      }
    }, 300);

  }
  confirmSaveItem(item) {
    console.info('item: ', item)

    console.info(" itemToSave ", this.itemToSave);
    console.info(" item ", item);


    if(!item.id && !item.code)
      item.code = this.generateUniqueString()

    if(!item.id && !item.codification)
      item.codification = this.generateUniqueString()

    
    // item.specialiteId = this.selectedSpecialite.id

    if (!item || !item.garant_id) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner garant !",
        "bottom",
        "center"
      );
      return;
    }

    if (!item || !item.police_id) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner police !",
        "bottom",
        "center"
      );
      return;
    }

    

    if (!item || !item.bareme_id) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner barème!",
        "bottom",
        "center"
      );
      return;
    }


    if (!item || !item.taux_couverture) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner taux couverture!",
        "bottom",
        "center"
      );
      return;
    }

    if (!item || !item.codification) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner codification!",
        "bottom",
        "center"
      );
      return;
    }

    if (!item || !item.libelle) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner libellé!",
        "bottom",
        "center"
      );
      return;
    }
    if (!item || !item.date_effet) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner date effet!",
        "bottom",
        "center"
      );
      return;
    }
    if (!item || !item.date_echeance) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner date écheance!",
        "bottom",
        "center"
      );
      return;
    }
    if (!item || !item.etendu_territoire_id) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner etendue térritoire!",
        "bottom",
        "center"
      );
      return;
    }
    if (!item || !(item.delai_carence>=0)) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner délai carence!",
        "bottom",
        "center"
      );
      return;
    }
    if (!item || !item.seuil_alerte_conso) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner seuil alerte conso!",
        "bottom",
        "center"
      );
      return;
    }
    if (!item || !item.seuil_suspension_tiers_payant) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner seuil suspension tiers  payant!",
        "bottom",
        "center"
      );
      return;
    }
    if (!item || !item.assure_remboursement) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner à qui rembourser!",
        "bottom",
        "center"
      );
      return;
    }

    // if (!item || !item.mode_tarification_id) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner mode tarification!",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }
    if (!item || !item.reseau_de_soin_id) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner mode tarification!",
        "bottom",
        "center"
      );
      return;
    }
    // if (!item || !item.mode_tarification_id) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner mode tarification!",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }
    // if (!item || !item.statut_college_id) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner statut collège!",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }

    if (!item.mode_gest_avenant ) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner le mode gestion avenant!",
        "bottom",
        "center"
      );
      return;
    }
    if (!item.periodicite_avenant) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner périodicité avenant!",
        "bottom",
        "center"
      );
      return;
    }
    if (item.is_prorata_prime && !item.mode_prorata_id ) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner le mode de prorata!",
        "bottom",
        "center"
      );
      return;
    }


    let objToSave = Object.assign({}, item);
    

    Swal.fire({
      title: this.capitalize(this.title),
      text: objToSave?.id
        ? this.editMessage
        : this.createMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0665aa",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then((result) => {
      if (result.value) {
        ;
        this.saveItem(objToSave);
      }
    });
  }


  getItemsTarif() {
            let request = {
              user_id: this.user.id,
              filiale_id: this.user.filiale_id,
              index: 0,
              size: 1000,
              data: {
                type_tarif_id: this.itemsTypeTarif.find(
                  (itt) => itt.codification == "TAR-COL"
                ).id,
              },
            };
        
            this.busyGet = this.restClient
              .post("tarif/getByCriteria", request)
              .subscribe(
                (res) => {
                  if (res && res["items"]) {
                    this.itemsTarif = _.orderBy(res["items"], ["libelle"], ["asc"]);
                  } else {
                    this.itemsTarif = [];
                  }
                },
                (err) => {
                  this.itemsTarif = [];
                }
              );
          }
  
  
          getItemsTypeTarif() {
                let request = {
                  user_id: this.user.id,
                  filiale_id: this.user.filiale_id,
                  index: 0,
                  size: 1000,
                  data: {
                    // type_tarif_id:this.itemto
                  },
                };
            
                this.busyGet = this.restClient
                  .post("typeTarif/getByCriteria", request)
                  .subscribe(
                    (res) => {
                      if (res && res["items"]) {
                        this.itemsTypeTarif = _.orderBy(res["items"], ["libelle"], ["asc"]);
                      } else {
                        this.itemsTypeTarif = [];
                      }
                      this.getItemsTarif();
                    },
                    (err) => {
                      this.itemsTypeTarif = [];
                    }
                  );
              }
  onSelectTypeRemboursement(){
    let selected_type_remboursement = this.itemsTypeRemboursement.find(itr=>itr.id == this.itemToSave.type_remboursement_id)
    this.is_tpg = selected_type_remboursement && selected_type_remboursement.codification == 'TPG'
    if(!this.itemToSave.taux_tpg){
      this.itemToSave.taux_tpg = 100
    }
    if(!this.itemToSave.plafond_tpg){
      this.itemToSave.plafond_tpg = 0
    }
    if(!this.itemToSave.majoration_tpg){
      this.itemToSave.majoration_tpg = 0
    }
  }

  
  saveItem(item) {
    console.info("item to save", item);

    this.loading = true;

    let itemAEnregistrer = Object.assign({}, item);
    let reduce = [];
    itemAEnregistrer.filiale_id = this.filiale_id || this.user.filiale_id
    var request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      datas: [itemAEnregistrer],
    };

    this.busySave = this.restClient
      .post(
        this.endPoint + "" + (itemAEnregistrer.id ? "/update" : "/create"),
        request
      )
      .subscribe(
        (res) => {
          console.info("resul", res);
          this.loading = false;

          if (!res["hasError"]) {
              this.utilities.showNotification(
                "snackbar-success",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );

              this.bsModalRef.hide();
          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            "snackbar-danger",
            this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center"
          );
          this.loading = false;
        }
      );
  }

  addDocument(event) {
    console.log("addDocument: ", event);
    // this.datasFile = event;
  }

  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("filiale/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            this.itemsFiliale = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsFiliale = [];
          }
        },
        (err) => { }
      );
  }

  getItemsTypeRemboursement() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("typeRemboursement/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsTypeRemboursement = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
            if(this.itemToSave.id){
              this.onSelectTypeRemboursement()
            }
          } else {
            this.itemsTypeRemboursement = [];
          }
        },
        (err) => { 
          this.itemsTypeRemboursement = [];

        }
      );
  }
  getItemsEtenduTerritoire() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("etendueTerritoire/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsEtenduTerritoire = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsEtenduTerritoire = [];
          }
        },
        (err) => { 
          this.itemsEtenduTerritoire = [];

        }
      );
  }
  getItemsCourtier() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("courtier/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsCourtier = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsCourtier = [];
          }
        },
        (err) => { 
          this.itemsCourtier = [];

        }
      );
  }

  getItemsCommercial() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("commercial/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsCommercial = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsCommercial = [];
          }
        },
        (err) => { 
          this.itemsCommercial = [];

        }
      );
  }

  getItemsModeTarification() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("modeTarification/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsModeTarification = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsModeTarification = [];
          }
        },
        (err) => { 
          this.itemsModeTarification = [];

        }
      );
  }
  getItemsSouscripteur() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("souscripteur/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsSouscripteur = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsSouscripteur = [];
          }
        },
        (err) => { 
          this.itemsSouscripteur = [];

        }
      );
  }
getItemsCategoriePolice() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("categoriePolice/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsCategoriePolice = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsCategoriePolice = [];
          }
        },
        (err) => { 
          this.itemsCategoriePolice = [];

        }
      );
}

getItemsReseauDeSoin() {
  let request = {
    user_id: this.user.id,
    filiale_id:this.user.filiale_id,
    index: 0,
    size: 1000,
    data: {},
  };

  this.busyGet = this.restClient
    .post("reseauDeSoin/getByCriteria", request)
    .subscribe(
      (res) => {
        if (res && res["items"]) {
          this.itemsReseauDeSoin = _.orderBy(
            res["items"],
            ["libelle"],
            ["asc"]
          );
        } else {
          this.itemsReseauDeSoin = [];
        }
      },
      (err) => { 
        this.itemsReseauDeSoin = [];

      }
    );
}
getItemsGarant() {
  let request = {
    user_id: this.user.id,
    filiale_id:this.user.filiale_id,
    index: 0,
    size: 1000,
    data: {},
  };

  this.busyGet = this.restClient
    .post("garant/getByCriteria", request)
    .subscribe(
      (res) => {
        if (res && res["items"]) {
          this.itemsGarant = _.orderBy(
            res["items"],
            ["libelle"],
            ["asc"]
          );

          if(this.itemToSave.id){
            // this.itemToSave.police_id=''
            this.itemToSearch.garant_id = this.itemToSave.garant_id
            this.getItemsPolice()
          }
        } else {
          this.itemsGarant = [];
        }
      },
      (err) => { 
        this.itemsGarant = [];

      }
    );
}

getItemsAgence() {
  let request = {
    user_id: this.user.id,
    filiale_id:this.user.filiale_id,
    index: 0,
    size: 1000,
    data: {},
  };

  this.busyGet = this.restClient
    .post("agence/getByCriteria", request)
    .subscribe(
      (res) => {
        if (res && res["items"]) {
          this.itemsAgence = _.orderBy(
            res["items"],
            ["libelle"],
            ["asc"]
          );
        } else {
          this.itemsAgence = [];
        }
      },
      (err) => { 
        this.itemsAgence = [];

      }
    );
}
getItemsStatutCollege() {
  let request = {
    user_id: this.user.id,
    filiale_id:this.user.filiale_id,
    index: 0,
    size: 1000,
    data: {},
  };

  this.busyGet = this.restClient
    .post("statutCollege/getByCriteria", request)
    .subscribe(
      (res) => {
        if (res && res["items"]) {
          this.itemsStatutCollege = _.orderBy(
            res["items"],
            ["libelle"],
            ["asc"]
          );
        } else {
          this.itemsStatutCollege = [];
        }
      },
      (err) => { 
        this.itemsStatutCollege = [];

      }
    );
}

getItemsPolice() {
  // if(!this.itemToSave.garant_id || !this.itemToSave.mode_tarification_id || !this.itemToSave.souscripteur_id)
  //   return
  if(!this.itemToSave.garant_id)
    return
  let cleanData = this.removeEmptyValues(this.itemToSearch)
  const isEmpty = (obj) => Object.keys(obj).length === 0;
  if(isEmpty(cleanData)){
    this.itemsPolice = []
    return
  }

  let request = {
    user_id: this.user.id,
    filiale_id:this.user.filiale_id,
    index: 0,
    size: 1000,
    // data: {...cleanData}
    data: {
            garant_id:this.itemToSave.garant_id,
            // souscripteur_id:this.itemToSave.souscripteur_id,
            // mode_tarification_id:this.itemToSave.mode_tarification_id
    }
    // data: {
    //   garant_id:this.itemToSave.garant_id || null,
    //   souscripteur_id:this.itemToSave.souscripteur_id || null
    // },
  };

  this.busyGet = this.restClient
    .post("police/getByCriteria", request)
    .subscribe(
      (res) => {
        if (res && res["items"]) {
          this.itemsPolice = _.orderBy(
            res["items"],
            ["libelle"],
            ["asc"]
          );
        } else {
          this.itemsPolice = [];
        }
      },
      (err) => { 
        this.itemsPolice = [];

      }
    );
}

removeEmptyValues(obj) {
  return Object.keys(obj)
    .filter(key => obj[key] !== null && obj[key] !== undefined && obj[key] !== '')
    .reduce((acc, key) => {
      acc[key] = obj[key];
      return acc;
    }, {});
}
getItemsBareme() {
  let request = {
    user_id: this.user.id,
    filiale_id:this.user.filiale_id,
    index: 0,
    size: 1000,
    data: {
      garant_id:this.itemToSave.garant_id
    },
  };

  this.busyGet = this.restClient
    .post("bareme/getByCriteria", request)
    .subscribe(
      (res) => {
        if (res && res["items"]) {
          this.itemsBareme = _.orderBy(
            res["items"],
            ["libelle"],
            ["asc"]
          );
          // this.itemsBareme = this.itemsBareme.filter(ib=>ib.produit_bareme.mode_tarification_id == this.selected_police)
          // this.itemsBareme = this.itemsBareme.filter(ib=>ib.produit_bareme.mode_tarification_id == this.selected_police)
          this.itemsBareme =_.orderBy(
            res["items"],
            ["libelle"],
            ["asc"]
          );
        } else {
          this.itemsBareme = [];
        }
      },
      (err) => { 
        this.itemsBareme = [];

      }
    );
}

onSelectModeTarification(){
  // this.getItemsBaremeByModeTarification()
  this.getItemsPolice()
}
getItemsBaremeByModeTarification() {
  // debugger
  if(!this.itemToSave.garant_id || !this.itemToSave.mode_tarification_id)return
  let request = {
    user_id: this.user.id,
    filiale_id:this.user.filiale_id,
    index: 0,
    size: 1000,
    data: {
      garant_id:this.itemToSave.garant_id,
      // mode_tarification_id:this.itemToSave.mode_tarification_id
    },
  };

  this.busyGet = this.restClient
    .post("bareme/getByModeTarification", request)
    .subscribe(
      (res) => {
        if (res && res["items"]) {
          this.itemsBareme = _.orderBy(
            res["items"],
            ["libelle"],
            ["asc"]
          );
          // this.itemsBareme = this.itemsBareme.filter(ib=>ib.produit_bareme.mode_tarification_id == this.selected_police)
          // this.itemsBareme = this.itemsBareme.filter(ib=>ib.produit_bareme.mode_tarification_id == this.selected_police)
          this.itemsBareme =_.orderBy(
            res["items"],
            ["libelle"],
            ["asc"]
          );
        } else {
          this.itemsBareme = [];
        }
      },
      (err) => { 
        this.itemsBareme = [];

      }
    );
}

  // onSelectDate(event) {
  //   if (event) {
  //     (this.dateNais = moment(event).format("DD/MM/YYYY")),
  //       console.info("dateNais", this.dateNais);
  //   }
  // }

isValidEmail(email) {
    // Regular expression for validating email addresses
    var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
}

generateUniqueString() {
  // Get current timestamp in milliseconds
  var timestamp = new Date().getTime();

  // Generate a random number
  var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

  // Concatenate timestamp and random number
  var uniqueString = timestamp.toString() + randomNumber.toString();

  return uniqueString;
}



capitalize(str) {
  return str.replace(/^\w/, (c) => c.toUpperCase());
}

load_filiale_data(){
  // this.getItems();
  this.getItemsTypeRemboursement()
}

onSelectPolice(){
  // this.itemToSave.garant_id=''
  
  if(this.itemsPolice && this.itemsPolice.length && this.itemToSave.police_id && !this.itemToSave.id){
    // this.itemToSave.garant_id = this.itemsPolice.filter(ip=>ip.id == this.itemToSave.police_id)[0].garant_id
    if(!this.itemToSave.souscripteur_id)
      this.itemToSave.souscripteur_id = this.itemsPolice.filter(ip=>ip.id == this.itemToSave.police_id)[0].souscripteur_id

    if(!this.itemToSave.garant_id)
      this.itemToSave.garant_id = this.itemsPolice.filter(ip=>ip.id == this.itemToSave.police_id)[0].garant_id
    
    if(!this.itemToSave.mode_tarification_id)
      this.itemToSave.mode_tarification_id = this.itemsPolice.filter(ip=>ip.id == this.itemToSave.police_id)[0].mode_tarification_id
    // this.getItemsBareme(this.itemToSave.garant_id)
    // this.itemToSave.souscripteur_id=this.itemToSave.souscripteur_id
    
    this.on_change_police()
    
  }
}

onSelectBareme(){
  // this.itemToSave.garant_id=''
  // debugger
  if(this.itemsBareme && this.itemsBareme.length && this.itemToSave.bareme_id){

    let currentBareme = this.itemsBareme.filter(ip=>ip.id == this.itemToSave.bareme_id)[0]
    console.log('currentBareme: ',currentBareme)
    this.itemToSave.taux_couverture = currentBareme.produit_bareme?.taux_couverture
    this.itemToSave.mode_tarification_id = currentBareme.produit_bareme?.mode_tarification_id
    
  }
}

onSelectGarant(){
  this.setSystemAvenantConfig()
  let current_garant = this.itemsGarant.find(ig=>ig.id == this.itemToSave.garant_id)
  // this.setGarantAvenantConfig(current_garant)
  if(!this.itemToSave.id)
    this.itemToSave.police_id=''
  this.itemToSearch.garant_id = this.itemToSave.garant_id
  this.getItemsPolice()
  // this.getItemsBareme(this.itemToSave.garant_id)
  // this.on_change_garant()
  this.getItemsBareme()
}

onSelectSouscripteur(){
  if(!this.itemToSave.id)
    this.itemToSave.police_id=''

  this.itemToSearch.souscripteur_id = this.itemToSave.souscripteur_id

  this.getItemsPolice()
  // this.getItemsBareme(this.itemToSave.garant_id)
  // this.on_change_garant()
}

on_change_garant(){
  // debugger
  if(this.itemsGarant && this.itemsGarant.length){
    let current_garant = {...this.itemsGarant.filter(ig=>ig.id == this.itemToSave.garant_id)[0]}
    console.log('current_garant: ',current_garant)

    if(!this.itemToSave.id){
      this.itemToSave.taux_commission_sinistre = current_garant.taux_commission_sinistre
      this.itemToSave.forfait_commission_sinistre = current_garant.forfait_commission_sinistre
      this.itemToSave.taux_commission_prime = current_garant.taux_commission_prime
      this.itemToSave.forfait_commission_prime = current_garant.forfait_commission_prime
      this.itemToSave.type_remboursement_id = current_garant.type_remboursement_id
      this.itemToSave.seuil_alerte_conso = current_garant.seuil_alerte_conso
      this.itemToSave.seuil_suspension_tiers_payant = current_garant.seuil_suspension_tiers_payant
      this.itemToSave.assure_remboursement = current_garant.assure_remboursement
      // this.itemToSave.mode_tarification_id = current_garant.mode_tarification_id
      this.itemToSave.mode_reconduction_id = current_garant.mode_reconduction_id
      this.itemToSave.mode_fractionnement_id = current_garant.mode_fractionnement_id
      this.itemToSave.reseau_de_soin_id = current_garant.reseau_de_soin_id
      this.itemToSave.is_prorata_prime = current_garant.is_prorata_prime
    }
  }
  
}
on_change_police(){
  let currentPolice:any = {}
  if(this.itemsPolice && this.itemsPolice.length)
    currentPolice = this.itemsPolice.filter(ip=>ip.id == this.itemToSave.police_id)[0]
  console.log('currentPolice: ',currentPolice)
  this.setPoliceAvenantConfig(currentPolice)
  this.itemToSave.date_effet = moment(currentPolice.date_effet).toDate()
  this.itemToSave.date_echeance = moment(currentPolice.date_echeance).toDate()
  this.itemToSave.delai_carence = currentPolice.delai_carence

    if(!this.itemToSave.id){
      this.itemToSave.taux_commission_sinistre = currentPolice.taux_commission_sinistre
      this.itemToSave.forfait_commission_sinistre = currentPolice.forfait_commission_sinistre
      this.itemToSave.taux_commission_prime = currentPolice.taux_commission_prime
      this.itemToSave.forfait_commission_prime = currentPolice.forfait_commission_prime
      this.itemToSave.type_remboursement_id = currentPolice.type_remboursement_id
      this.itemToSave.seuil_alerte_conso = currentPolice.seuil_alerte_conso
      this.itemToSave.seuil_suspension_tiers_payant = currentPolice.seuil_suspension_tiers_payant
      this.itemToSave.assure_remboursement = currentPolice.assure_remboursement
      // this.itemToSave.mode_tarification_id = currentPolice.mode_tarification_id
      this.itemToSave.mode_reconduction_id = currentPolice.mode_reconduction_id
      this.itemToSave.mode_fractionnement_id = currentPolice.mode_fractionnement_id
      this.itemToSave.reseau_de_soin_id = currentPolice.reseau_de_soin_id
      this.itemToSave.is_prorata_prime = currentPolice.is_prorata_prime
    }
    this.itemToSave.bareme_id=''
    this.selected_police = currentPolice
    // this.getItemsBareme(this.itemToSave.garant_id,currentPolice)
    // this.getItemsBareme()
    // this.getItemsBaremeByModeTarification()

  }
  

openModalPrestataireReseau() {
  if(!this.itemToSave.reseau_de_soin_id)
    return
  let modal: any;
  modal = ModalViewreseauDeSoinDetailComponent;
  this.modalRef = this.modalService.show(modal, {
    id: 5458545,
    class: "modal-width-75",
    ignoreBackdropClick: true,
    // data:boulangerie
  });
  let reseau_id = this.itemToSave.reseau_de_soin_id
  let reseau_de_soin_libelle = this.itemsReseauDeSoin.filter(ird=>ird.id == reseau_id)[0].libelle
  let data = {reseau_de_soin_id:reseau_id,reseau_de_soin_libelle:reseau_de_soin_libelle}
  if (data) this.modalRef.content.currentData = data;
  this.modalRef.onHide.subscribe((res) => {
  });
}

openModalDetailBareme() {
  console.log('itemToSave: ',this.itemToSave)
  if(!this.itemToSave.bareme_id)
    return
  let modal: any;
  modal = ModalViewBaremeDetailComponent;
  this.modalRef = this.modalService.show(modal, {
    id: 545854512,
    class: "modal-width-90",
    ignoreBackdropClick: true,
    // data:boulangerie
  });
  let bareme_libelle ='' 
  if(this.itemsBareme && this.itemsBareme.length)
    bareme_libelle = this.itemsBareme.filter(ib=>ib.id == this.itemToSave.bareme_id)[0].libelle
  let data = {bareme_id:this.itemToSave.bareme_id,bareme_libelle:bareme_libelle}
  if (data) this.modalRef.content.currentData = data;
  this.modalRef.onHide.subscribe((res) => {
  });
}

getItemsModeProrata() {
  let request = {
    user_id: this.user.id,
    filiale_id:this.user.filiale_id,
    index: 0,
    size: 1000,
    data: {},
  };

  this.busyGet = this.restClient
    .post("modeProrata/getByCriteria", request)
    .subscribe(
      (res) => {
        if (res && res["items"]) {
          this.itemsModeProrata = _.orderBy(
            res["items"],
            ["libelle"],
            ["asc"]
          );
        } else {
          this.itemsModeProrata = [];
        }
      },
      (err) => { 
        this.itemsModeProrata = [];

      }
    );
}

openModalAddBareme(data?) {
  let modal: any;
  modal = ModalAddBaremeComponent;
  this.modalRef = this.modalService.show(modal, {
    id: this.generateUniqueString(),
    class: "modal-width-100",
    ignoreBackdropClick: true,
    
    // data:boulangerie
  });
  if (data) this.modalRef.content.currentData = data;
  this.modalRef.onHide.subscribe((res) => {
    this.currentPage = 0
    this.getItemsBareme();
  });
}

openAddGarantModal(data?){
  let modal: any;
  modal = ModalAddGarantComponent;
  this.modalRef = this.modalService.show(modal, {
    id: 5458540115,
    class: "modal-width-75",
    ignoreBackdropClick: true,
    // data:boulangerie
  });
  if (data) this.modalRef.content.currentData = data;
  this.modalRef.onHide.subscribe((res) => {
    this.getItemsGarant()
  });
}

openAddPoliceModal(data?){
  let modal: any;
  modal = ModalAddPoliceComponent;
  this.modalRef = this.modalService.show(modal, {
    id: 545854015,
    class: "modal-width-75",
    ignoreBackdropClick: true,
    // data:boulangerie
  });
  if (data) this.modalRef.content.currentData = data;
  this.modalRef.onHide.subscribe((res) => {
    this.getItemsPolice()
  });
}

setGarantAvenantConfig(current_garant){
  if(current_garant.mode_gest_avenant){
    this.itemToSave.mode_gest_avenant = current_garant.mode_gest_avenant
  }
  if(current_garant.periodicite_avenant){
    this.itemToSave.periodicite_avenant = current_garant.periodicite_avenant

  }
}
setPoliceAvenantConfig(current_police){
  if(current_police.mode_gest_avenant){
    this.itemToSave.mode_gest_avenant = current_police.mode_gest_avenant
  }
  if(current_police.periodicite_avenant){
    this.itemToSave.periodicite_avenant = current_police.periodicite_avenant

  }
}

setSystemAvenantConfig(){
  this.systemGlobal = JSON.parse(localStorage.getItem("globalSystem"));
      // console.log('systemGlobal: ',JSON.stringify(this.systemGlobal))


      if(this.systemGlobal && this.systemGlobal.length){
        this.itemToSave.mode_gest_avenant = this.systemGlobal.find(
          (sg: any) => sg.codification == "mode_gest_avenant"
        ).valeur;
  
        this.itemToSave.periodicite_avenant = this.systemGlobal.find(
          (sg: any) => sg.codification == "periodicite_avenant"
        ).valeur;
      }

      
}



  ngOnInit() {

    this.getItemsFiliale();
    this.getItemsTypeRemboursement()
    this.getItemsCourtier()
    this.getItemsCommercial()
    this.getItemsSouscripteur()
    this.getItemsCategoriePolice()
    this.getItemsModeTarification()
    this.getItemsReseauDeSoin()
    this.getItemsAgence()
    this.getItemsStatutCollege()
    this.getItemsGarant()
    this.getItemsModeProrata()
    this.getItemsEtenduTerritoire()
    this.getItemsTypeTarif()
    // this.getItemsPolice()
  }

}
